import { analogue,complement,saturation,triad,rotation,lightness,opacity,harmony,colorScheme } from 'simpler-color'

export const hexToRgbA = function(hex,op){
    var c;
    if (hex.indexOf("rgb") > -1){
        var pts = hex.split("(").pop().split(")").shift().split(",");
        return {r:pts[0],g:pts[1],b:pts[2],a:(pts.length > 3)?pts[3]:1}
    }
    hex = (hex.indexOf("#") > -1)?hex:"#"+hex;
    op = (hex.length == 9) ? ("."+(parseInt(hex.slice(7))/100)).split(".").pop() : 1;
    hex = (hex.length == 9) ? hex.slice(0,7) : hex;

    
    if(/^#([A-Fa-f0-9]{2}){3,4}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        var all = [(c>>16)&255, (c>>8)&255, c&255,op];
        return {r:all[0],g:all[1],b:all[2],a:all[3]}
    }
    throw new Error('Bad Hex');
   }
 
export const buildFromThree = (lp) => {
    const opts =[lightness,rotation,saturation,analogue,complement,harmony];
    const range = Array.from(Array(100).keys());
    const looper = ["primary","secondary","accent"];
    var ct = "primary";
    var tc = {};
    const rgb2hex = (colorval) => {
        if (colorval.indexOf("rgb") < 0){
            return colorval;
        }
        if (colorval.indexOf("rgba") > -1){
           return rgba2hex(colorval);
        }
        var parts = colorval.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        delete(parts[0]);
        for (var i = 1; i <= 3; ++i) {
            parts[i] = parseInt(parts[i]).toString(16);
            if (parts[i].length == 1) parts[i] = '0' + parts[i];
        }
        var color = '#' + parts.join('');
       
        return color;
       }
    lp.map((c,z) => {
        ct = (z > 1) ? "accent" : (z > 0) ? "secondary" : "primary";
        tc[ct] = c;
    });
    var idx = 0;
    lp.map((c,k) => {
        
        var col = tc[looper[k]];
        col = (col.indexOf("rgb") > -1) ? rgb2hex(col) : col;
  
    var all = harmony(saturation(lightness(col,40),40));
        delete all.error;
        delete all.neutral;
        delete all.accent;
        tc["--charts-"+idx] = all.primary;
        idx++;
        tc["--charts-"+idx] = all.secondary;
    Object.keys(all).map((am) => {
      var cs = colorScheme(
        {primary:all[am]},
        colors=>({
            p:saturation(lightness(colors.primary(30),70),60),
            s:saturation(lightness(colors.primary(50),50),60)
        }),
      )
      
       Object.keys(cs).map((n) => {tc["--charts-"+idx] = cs[n];idx++});
    });
  

      var y = 0
      ct = (k > 1) ? "accent" : (k > 0) ? "secondary" : "primary";
        tc[ct] = c;
        tc["--primary"] = tc["primary"];
          tc["--secondary"] = tc["secondary"];
          tc["--accent"] = tc["accent"];
         for (var n of range){
          if (n < 5){
          var x = (n+1);
          var o = opts[0];
          var c = (x == 1) ? 25 : (x*18);
          tc["--primary-"+x] = o(tc["primary"],c)
          tc["--secondary-"+x] = o(tc["secondary"],c)
          tc["--accent-"+x] = o(tc["accent"],c)
          }         
            
         
        }
    });
return tc;
}


export const ThemeColors = () => {
  let rootStyle = getComputedStyle(document.body);
  return {
     themeColor1 : rootStyle.getPropertyValue("--primary").trim(),
     themeColor2 : rootStyle.getPropertyValue("-secondary").trim(),
     themeColor3 : rootStyle.getPropertyValue("--accent").trim(),
     primary1:rootStyle.getPropertyValue("--primary-1").trim(),
     primary2:rootStyle.getPropertyValue("--primary-2").trim(),
     primary3:rootStyle.getPropertyValue("--primary-3").trim(),
     primary4:rootStyle.getPropertyValue("--primary-4").trim(),
     primary5:rootStyle.getPropertyValue("--primary-5").trim(),
     secondary1:rootStyle.getPropertyValue("--secondary-1").trim(),
     secondary2:rootStyle.getPropertyValue("--secondary-2").trim(),
     secondary3:rootStyle.getPropertyValue("--secondary-3").trim(),
     secondary4:rootStyle.getPropertyValue("--secondary-4").trim(),
     secondary5:rootStyle.getPropertyValue("--secondary-5").trim(),
     accent1:rootStyle.getPropertyValue("--accent-1").trim(),
     accent2:rootStyle.getPropertyValue("--accent-2").trim(),
     accent3:rootStyle.getPropertyValue("--accent-3").trim(),
     accent4:rootStyle.getPropertyValue("--accent-4").trim(),
     accent5:rootStyle.getPropertyValue("--accent-5").trim(),
    
     hexToRgbA:  (hex,op) =>{
        var c;
        if (hex.indexOf("rgb") > -1){
            return hex;
        }
        hex = (hex.indexOf("#") > -1)?hex:"#"+hex;
        
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+op+')';
        }
        throw new Error('Bad Hex');
       }
 }
}

export const CalculateColors = (obj,defs=false) => {
var getNewBrightnessColor = function(rgbcode, brightness) {
 rgbcode = (rgbcode.indexOf("#") > -1)?rgbcode:"#"+rgbcode;
 var r = parseInt(rgbcode.slice(1, 3), 16);
 var g = parseInt(rgbcode.slice(3, 5), 16);
 var b = parseInt(rgbcode.slice(5, 7), 16);
 var HSL = rgbToHsl(r, g, b);
 var RGB;
     
 var orig = HSL[2] * 100;
 var newbr = ((orig+brightness) > 100)?100:((orig+brightness)< 0)?0:(orig+brightness);
 RGB = hslToRgb(HSL[0], HSL[1], newbr / 100);
 rgbcode = '#'
     + convertToTwoDigitHexCodeFromDecimal(RGB[0])
     + convertToTwoDigitHexCodeFromDecimal(RGB[1])
     + convertToTwoDigitHexCodeFromDecimal(RGB[2]);
 
 return rgbcode;
}

function rgba2hex (color){
    if (/^rgb/.test(color)) {
      const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
  
      // rgb to hex
      // eslint-disable-next-line no-bitwise
      let hex = `#${((1 << 24) + (parseInt(rgba[0], 10) << 16) + (parseInt(rgba[1], 10) << 8) + parseInt(rgba[2], 10))
        .toString(16)
        .slice(1)}`;
  
      // added alpha param if exists
      if (rgba[4]) {
        const alpha = Math.round(0o1 * 255);
        const hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
        hex += hexAlpha;
      }
  
      return hex;
    }
    return color;
  };
function rgb2hex(colorval) {
 if (colorval.indexOf("rgb") < 0){
     return colorval;
 }
 if (colorval.indexOf("rgba") > -1){
    return rgba2hex(colorval);
 }
 var parts = colorval.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
 delete(parts[0]);
 for (var i = 1; i <= 3; ++i) {
     parts[i] = parseInt(parts[i]).toString(16);
     if (parts[i].length == 1) parts[i] = '0' + parts[i];
 }
 var color = '#' + parts.join('');

 return color;
}
var hexToRgbA = function(hex,op){
 var c;
 if (hex.indexOf("rgb") > -1){
     return hex;
 }
 hex = (hex.indexOf("#") > -1)?hex:"#"+hex;
 
 if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
     c= hex.substring(1).split('');
     if(c.length== 3){
         c= [c[0], c[0], c[1], c[1], c[2], c[2]];
     }
     c= '0x'+c.join('');
     return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+op+')';
 }
 throw new Error('Bad Hex');
}
var convertToTwoDigitHexCodeFromDecimal = function(decimal){
 var code = Math.round(decimal).toString(16);
 
 (code.length > 1) || (code = '0' + code);
 return code;
}

var rgbToHsl = function(r, g, b){
 r /= 255;
 g /= 255;
 b /= 255;
 var max = Math.max(r, g, b), min = Math.min(r, g, b);
 var h, s, l = (max + min) / 2;

 if(max == min){
     h = s = 0; // achromatic
 }else{
     var d = max - min;
     s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
     switch(max){
         case r: h = (g - b) / d + (g < b ? 6 : 0); break;
         case g: h = (b - r) / d + 2; break;
         case b: h = (r - g) / d + 4; break;
     }
     h /= 6;
 }

 return [h, s, l];
}

var hslToRgb = function(h, s, l){
 var r, g, b;

 if(s == 0){
     r = g = b = l; // achromatic
 }else{
     function hue2rgb(p, q, t){
         if(t < 0) t += 1;
         if(t > 1) t -= 1;
         if(t < 1/6) return p + (q - p) * 6 * t;
         if(t < 1/2) return q;
         if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
         return p;
     }

     var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
     var p = 2 * l - q;
     r = hue2rgb(p, q, h + 1/3);
     g = hue2rgb(p, q, h);
     b = hue2rgb(p, q, h - 1/3);
 }

 return [r * 255, g * 255, b * 255];
}
var defaults = {
    "--primary": "rgba(252, 84, 4, 1)",
    "--primary-1": "rgba(126, 42, 2, 1)",
    "--primary-2": "rgba(181, 60, 2, 1)",
    "--primary-3": "rgba(252, 97, 23, 1)",
    "--primary-4": "rgba(253, 159, 114, 1)",
    "--primary-5": "rgba(254, 221, 205, 1)",
    "--secondary": "rgba(58, 170, 248, 1)",
    "--secondary-1": "rgba(4, 74, 123, 1)",
    "--secondary-2": "rgba(6, 107, 177, 1)",
    "--secondary-3": "rgba(28, 157, 247, 1)",
    "--secondary-4": "rgba(117, 196, 250, 1)",
    "--secondary-5": "rgba(206, 234, 253, 1)",
    "--accent": "rgba(223, 180, 32, 1)",
    "--accent-1": "rgba(112, 90, 16, 1)",
    "--accent-2": "rgba(161, 130, 23, 1)",
    "--accent-3": "rgba(226, 186, 50, 1)",
    "--accent-4": "rgba(237, 213, 130, 1)",
    "--accent-5": "rgba(249, 240, 210, 1)",
    "--charts": "rgba(242, 80, 3, 1)",
    "--chartTextDark": "rgba(141, 47, 2, 1)",
    "--chartTextLight": "rgba(254, 193, 164, 1)",
    "--charts-1": "rgba(252, 84, 4, 1)",
    "--chartTextDark-1": "rgba(96, 141, 2, 1)",
    "--chartTextLight-1": "rgba(225, 254, 164, 1)",
    "--charts-2": "rgba(58, 170, 248, 1)",
    "--chartTextDark-2": "rgba(2, 141, 47, 1)",
    "--chartTextLight-2": "rgba(164, 254, 193, 1)",
    "--charts-3": "rgba(223, 180, 32, 1)",
    "--chartTextDark-3": "rgba(47, 2, 141, 1)",
    "--chartTextLight-3": "rgba(193, 164, 254, 1)",
    "--charts-4": "rgba(255, 83, 1, 1)",
    "--chartTextDark-4": "rgba(141, 2, 96, 1)",
    "--chartTextLight-4": "rgba(254, 164, 225, 1)",
    "--charts-5": "rgba(36, 140, 255, 1)",
    "--chartTextDark-5": "rgba(141, 47, 2, 1)",
    "--chartTextLight-5": "rgba(254, 193, 164, 1)",
    "--charts-6": "rgba(51, 171, 255, 1)",
    "--chartTextDark-6": "rgba(96, 141, 2, 1)",
    "--chartTextLight-6": "rgba(225, 254, 164, 1)"
}


 if (obj.defaultColors){
     obj = {...defaults,...{realTime:obj.realTime}};
 }

     let root = document.documentElement;
if (obj.realTime){
     for (var prop in obj){
         if (obj.hasOwnProperty(prop)){
             var el = obj[prop];
             
             if (prop.indexOf("--") > -1 || prop.indexOf("--") > -1){
                 el = (rgb2hex(el));
                 
                 root.style.setProperty(prop, hexToRgbA(el,1));
                
             }else{
                if (el.indeOf && el.indexOf("rgb") > -1){
                   root.style.setProperty(prop, el); 
                }
             }
         }
        }
       
   }else{
    var rhex = [];
    var iter = (obj.theme && Object.keys(obj.theme).length > 0) ? obj.theme : obj.themeColors;
    for (var prop in iter){
        if (iter.hasOwnProperty(prop)){
            if (typeof iter[prop] == 'string'){
            var el = iter[prop];
            if (el.indexOf("#") == -1){
                el = (rgb2hex(el));
                var rh =  hexToRgbA(el,1);
            }else{
                rh = el;
            }
                rhex.push(el);
                if (obj.returnHex){}else{
                root.style.setProperty(prop,rh);
                }
            }
        }
       }
   }
   if (obj.returnHex){
    return rhex;
   }
}



